/**
 * Map backend world_id / level_id strings to translated labels.
 *
 * Backend serves English names ("Couch to Active", "Step 1", "Lap 3"…).
 * On the client we keep the IDs as the source of truth and resolve a
 * human-readable label via i18n so the journey screen + dashboard
 * "Continue · {{name}}" CTA + share text all render in the user's
 * selected language.
 *
 * Pure functions (no React hooks) — pass in the `t` from useTranslation.
 */

// Level id → translation key + extractor for the index. Each world emits
// ids like `ca_3`, `fk_7`, `mp_1`, `bc_4`, `iw_9` (see backend/config.py).
const LEVEL_PREFIXES = [
  { prefix: "ca_", key: "journey.level_step" },
  { prefix: "fk_", key: "journey.level_lap" },
  { prefix: "mp_", key: "journey.level_mile" },
  { prefix: "bc_", key: "journey.level_rep" },
  { prefix: "iw_", key: "journey.level_round" },
];

const WORLD_TITLE_KEYS = {
  couch_to_active: "journey.world_couch_to_active_title",
  "5k_training": "journey.world_5k_training_title",
  marathon_prep: "journey.world_marathon_prep_title",
  boot_camp: "journey.world_boot_camp_title",
  iron_will: "journey.world_iron_will_title",
};

const WORLD_SUBTITLE_KEYS = {
  couch_to_active: "journey.world_couch_to_active_subtitle",
  "5k_training": "journey.world_5k_training_subtitle",
  marathon_prep: "journey.world_marathon_prep_subtitle",
  boot_camp: "journey.world_boot_camp_subtitle",
  iron_will: "journey.world_iron_will_subtitle",
};

export function translateWorldTitle(world, t) {
  if (!world) return "";
  const key = WORLD_TITLE_KEYS[world.world_id];
  return key ? t(key, world.title) : world.title || "";
}

export function translateWorldSubtitle(world, t) {
  if (!world) return "";
  const key = WORLD_SUBTITLE_KEYS[world.world_id];
  return key ? t(key, world.subtitle) : world.subtitle || "";
}

export function translateLevelName(levelOrId, t, fallback) {
  const id = typeof levelOrId === "string" ? levelOrId : levelOrId?.level_id;
  const fb = fallback ?? (typeof levelOrId === "object" ? levelOrId?.name : id);
  if (!id) return fb || "";
  for (const { prefix, key } of LEVEL_PREFIXES) {
    if (id.startsWith(prefix)) {
      const n = Number(id.slice(prefix.length));
      if (Number.isFinite(n)) return t(key, { n });
    }
  }
  return fb || id;
}
